/* src/app/feature-modules/schools/create-edit-school/create-edit-school.component.css */
.sub-entry {
  width: 50%;
  float: left;
}
/*# sourceMappingURL=create-edit-school.component.css.map */
